// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/same-value.js
// module id = 290
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33